import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { useEffect, useRef } from 'react'
import { ImageNode, $isImageNode } from '../../../node/ImageNode'
import { $getNodeByKey } from 'lexical'

export default function ImageDeletePlugin() {
  const [editor] = useLexicalComposerContext()
  const nodeDataMapRef = useRef(new Map())

  useEffect(() => {
    return editor.registerMutationListener(ImageNode, (mutatedNodes) => {
      editor.getEditorState().read(() => {
        for (const [nodeKey, mutation] of mutatedNodes) {
          if (mutation === 'created' || mutation === 'updated') {
            const node = $getNodeByKey(nodeKey)
            if ($isImageNode(node)) {
              nodeDataMapRef.current.set(nodeKey, node)
            }
          } else if (mutation === 'destroyed') {
            const node = nodeDataMapRef.current.get(nodeKey)
            if ($isImageNode(node)) {
              console.log('Image node deleted:', nodeKey, node)
              // http.del("/api/v1/file", [...])
              nodeDataMapRef.current.delete(nodeKey)
            }
          }
        }
      })
    })
  }, [editor])

  return null
}
